<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">8. Grupos de serviço</div>
    <div v-if="!loading">
      <div style="min-height: 506px" v-if="qtTotal > 0">
        <unicom-linha
          :espacamento="false"
          v-for="(grupo, index) in rowsComputed"
          :key="index"
          class="medio espacamento-tabela"
          :class="{ par: index % 2 === 0 }"
        >
          <unicom-coluna
            sm="12"
            md="6"
            :class="$breakpoint.smAndDown ? 'mb-2' : ''"
          >
            <div>Grupo de serviço {{ grupo.codigo }}:</div>
          </unicom-coluna>
          <unicom-coluna sm="12" md="6">
            {{ grupo.nome }}
          </unicom-coluna>
        </unicom-linha>
      </div>
      <unicom-paginacao-v3
        v-if="qtTotal > 0"
        :mostrarBotaoUltimo="false"
        textoExibindo="resultados"
        :qtPaginaAtual="qtPaginaAtual"
        :qtTotal="this.zeroEsquerda(qtTotal, 2)"
        :qtPaginas="qtPaginas"
        v-model="pagina"
      />
      <div class="medio negrito" v-else>Não contém nenhum grupo de serviço</div>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      v-show="loading"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";
import TabelaFrontMixin from "@/shared/mixin/TabelaFrontMixin";

export default {
  name: "GrupoServico",
  mixins: [DadosGeraisMixin, TabelaFrontMixin],
  data() {
    return {
      grupoServico: []
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getGrupoServico(this.idRnpPrestador)
          .then(res => {
            this.rows = res.data;
            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.par {
  background: #f2f5f4;
}

.espacamento-tabela {
  padding: 16px;
  padding-left: 24px;
}
</style>
